import { Controller } from "@hotwired/stimulus";

// Marks the latest announcement as read (PATCH) and removes the announcement
// bell from the page. Replaces the old Alpine `markAsRead()` in
// `_announcement_dialog.html.erb` — and adds the CSRF token the Alpine version
// was missing (its PATCH would have been rejected by Rails).
export default class extends Controller {
  markRead() {
    const url = this.element.dataset.announcementUrl;

    fetch(url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": csrfToken(),
      },
    })
      .then((res) => {
        if (res.ok) {
          // one for mobile, one for desktop
          document
            .querySelectorAll("#announcement-bell")
            .forEach((el) => el.remove());
        }
      })
      .catch((error) => console.error("Error:", error));
  }
}

function csrfToken() {
  return (
    document
      .querySelector('meta[name="csrf-token"]')
      ?.getAttribute("content") ?? ""
  );
}
